(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-content-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bs-content-video')) {
  customElements.define('bs-content-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('[data-bs-content-play]')?.addEventListener('click', () => {
        const frame = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
        if (!frame) return;
        if (this.dataset.provider === 'facebook') {
          const source = new URL(frame.src);
          source.searchParams.set('width', Math.round(this.clientWidth));
          source.searchParams.set('height', Math.round(this.clientHeight));
          frame.src = source.href;
        }
        this.classList.add('is-playing');
        this.replaceChildren(frame);
        frame.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
